import { type ComponentType, useEffect } from "react";
import { useLocation } from "react-router";
import { useBreadcrumbTrail } from "./useBreadcrumbTrail.ts";

export const useTrailLabel = (label: string, icon?: ComponentType) => {
  const { updateEntry } = useBreadcrumbTrail();
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    updateEntry(pathname, search, hash, label, icon);
  }, [updateEntry, pathname, search, hash, label, icon]);
};
